import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a9fb874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "payment-title" }, "ohhhh lè", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "payment-subtitle" }, "Typical cremonese way to highlight the finish of a long task", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "payment-body" }, [
  /*#__PURE__*/_createTextVNode(" 💸 Grazie di aver acquistato con noi! 💸"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Ci vediamo a Cremona!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Ti abbiamo inviato una mail con il riepilogo del tuo ordine ")
], -1))
const _hoisted_5 = { class: "payment-actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Continua a visitare il sito")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/merch",
        class: "btn btn-pc btn-pc-secondary ms-auto"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ])
  ]))
}